import React from "react";
import { useTranslation } from "react-i18next";
const TermsAndConditions = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="text-right mb-4"> {t("شرایط و قوانین")} </p>
      <div className="textCard text-justify p-3 m-3">
        {/* <p className="m-0 fn12">
          متن حاضر دربرگیرنده‌ی شرایطی است که شما با مشاهده یا استفاده از محتوا،
          ابزارها و سرویس‌های ماندگار مدار آوین، در جایگاه یک کاربر عادی یا یک
          کاربر عضوشده، می‌پذیرید. این توافق‌نامه رابطه‌ی میان ما یعنی
          عرضه‌کننده‌ی خدمات زیرساخت و شما، کاربر گرامی را شفاف‌تر می‌کند و با
          بروز اختلاف میان ما و شما، برای داوری یا قضاوت در مراجع قانونی حل
          اختلاف می‌تواند مورد استفاده قرار گیرد.
          <br />
          کاربر با ثبت نام در ماندگار مدار آوین و استفاده از هر یک از خدمات ما
          تایید می‌کند که از مفاد شرایط استفاده از خدمات مطلع بوده و آن‌ها را
          مورد پذیرش قرار داده و به موارد مطرح شده در مستند پای‌بند است.
          <br />
          از آن‌جایی که ممکن است مفاد مستندات در هر زمان از سوی شرکت ماندگار
          مدار آوین، مورد بازبینی و به‌روزرسانی قرار گیرد، لازم است کاربر همواره
          به لینک‌های مربوط به هر کدام مراجعه کند و از به‌روزرسانی و تغییرات
          احتمالی آن‌ها آگاه شود. اگر چه عدم مراجعه کاربر به این اسناد، مانع از
          اجرای مفاد آن نخواهد بود و این مستندات بلافاصله پس از هر گونه تغییر،
          به اجرا گذاشته خواهد شد.
          <br />
          هر گونه مشاهده یا استفاده‌ی شما از هر یک از اجزای وب‌سایت ، پلتفرم ،
          اپلیکیشن و خدمات ماندگار مدار آوین به‌معنی اطلاع، موافقیت، پذیرش و
          پای‌بندی به مفاد اسناد است. از این رو خواهشمندیم اگر هر یک از مفاد
          مستندات برای‌تان قابل پذیرش نیست، به بهره‌گیری از خدمات ارائه شده یا
          مشاهده‌ی تارنمای ماندگار مدار آوین خاتمه دهید. حقوق معنوی ما از اسامی
          ماندگار، ماندگار مدار آوین، خانه هوشمند ماندگار، ماندگار کلاد،
          Mandegar، Mandegar Madar Avin و دیگر ترکیب‌های این کلمات استفاده
          می‌کنیم. مالکیت انحصاری و تمام حقوق مادی و معنوی این اسم، ایده‌های
          به‌کارگیری شده، محصول، سرویس و محتوای منتشر شده به هر شکل در وب‌سایت
          mmaviot.com و تحت هر زیردامنه‌ی آن برای شرکت ماندگار مدار آوین (سهامی
          خاص) محفوظ است و استفاده و بهره‌برداری از آن به هر شکل و با هر نیتی،
          برای پروژه‌ها و امور شخصی، تجاری یا عام‌المنفعه، اعم از مستقیم یا
          غیرمستقیم، بدون مجوز کتبی از ماندگار مدار آوین ممنوع و غیرمجاز است.
          رابط‌های گرافیکی، طراحی و تصویرسازی‌ها، اطلاعات و داده‌ها، کدهای
          کامپیوتری، متون آموزشی و دیگر عناصر تولیدشده‌ی ماندگار مدار آوین از
          مصادیق محتوای منتشر شده هستند. به هنگام هرگونه بهره‌برداری غیرمجاز، حق
          ماندگار مدار آوین بر اقامه‌ی دعاوی قانونی مرتبط و پی‌گیری حقوق خود از
          مجاری قانونی محفوظ خواهد بود. قوانین جمهوری اسلامی ایران شرکت ماندگار
          مدار آوین در کشور ایران ثبت شده است و تحت قوانین جمهوری اسلامی ایران
          فعالیت می‌کند؛ در نتیجه، اقدام هرگونه عمل مجرمانه از نظر قوانین جمهوری
          اسلامی ایران یا محافظت از آن به‌ کمک خدمات ماندگار مدار آوین به هر
          شکلی، برخلاف قانون و ناقض شروط این توافق‌نامه است. ما اعمال مجرمانه را
          در ماندگار مدار آوین نمی‌پذیریم و به‌محض آگاهی یافتن از توزیع و محافظت
          چنین محتوایی، از این امر جلوگیری خواهیم کرد؛ در چنین حالتی وجه دریافتی
          از مشتری نیز برگردانده نخواهد شد.
          <br />
          استفاده از ادوات و تجهیزات هوشمند و همچنین پلتفرم ماندگار مدار آوین در
          جهت اعمال مجرمانه ، تجهیزات کشتار جمعی، همکاری و حمایت از گروه‌های
          تروریستی و تجزیه‌طلب داخلی و خارجی یا هر فعالیت دیگری که مغایر با
          قوانین جمهوری اسلامی ایران باشد، مشمول ممنوعیت توزیع و محافظت در
          ماندگار مدار آوین خواهد شد. حقوق مولف (Copyright) و سایر قوانین نافذ
          بین‌المللی شما با استفاده از خدمات ماندگار مدار آوین می‌پذیرید که
          قوانین ایران و عرف بین‌المللی اینترنت و قوانین و عرف نافذ در هر مورد
          یا منطقه مشمول خدمات ماندگار مدار آوین را رعایت می‌کنید و هیچ‌گونه
          اقدامی که به هر شکل موجب ایجاد هرگونه مسوولیت برای ماندگار مدار آوین
          شود، انجام نمی‌دهید و با وقوع این امر، تمامی مسوولیت‌های قانونی مرتبط
          را به‌عهده می‌گیرید.
          <br />
          ماندگار مدار آوین این حق را برای خود محفوظ می‌دارد که در هر زمان
          براساس درخواست‌ها، شکایت‌ها و گزارش‌های وارده از سوی سازمان‌ها و
          نهادهای نافذ اینترنت و امنیت و نهادها و اشخاص ذی‌صلاح، نسبت به ارایه‌ی
          اطلاعات استفاده‌کننده از IP یا زیرساخت یا توقف عرضه‌ی خدمات به کاربر
          اقدام کند. در این موقعیت، وجوه پرداختی برگردانده نخواهد شد. اطلاعات
          محرمانه شما با عضویت و استفاده از محصولات ماندگار مدار آوین و با
          ذخیره‌ی داده‌ها یا عبور ترافیک وب‌سایت خود از این سامانه‌ی ابری، اجازه
          می‌دهید شرکت ماندگار مدار آوین در چهارچوب سیاست حفظ حریم خصوصی خود،
          تمام درخواست‌های ارسالی کاربران سایت‌تان را دریافت، بررسی و تحلیل کند،
          از حملات احتمالی جلوگیری به‌عمل آورد و محتوای پالایش‌ شده را به
          سرور(های) اصلی بفرستد. آمار و گزارش‌های به‌دست آمده از مجموعه‌ی این
          عملیات‌ها در پنل کاربری در اختیار شما قرار خواهد گرفت. تمام اطلاعات
          مربوط به یک وب‌سایت، شامل اطلاعات تماس صاحبان آن محتوا، مشخصات و رفتار
          کاربران، میزان و توزیع کاربری و Certificateها نزد ماندگار مدار آوین
          محرمانه قلمداد می‌شود و به‌جز در موارد الزام قانونی در اختیار هیچ شرکت
          یا نهاد ایرانی یا بین‌المللی قرار نخواهد گرفت. اطلاعات غيرمحرمانه
          ماندگار مدار آوین اجازه دارد اطلاعات و ترافیک عبوریافته از سیستم خود
          را پردازش کند و از آن به‌شکل تحلیلی برای استفاده در راستای بهبود
          سرویس‌دهی، استقرار‌ پاپ‌های جدید، توسعه‌ی خدمات یا سایر موارد موردنیاز
          استفاده و به هنگام نیاز، گزارش‌هایی را نیز منتشر کند. این اطلاعات با
          در نظر گرفتن محرمانگی اطلاعات مورد استفاده قرار خواهد گرفت.
          <br />
          توجه: حکم قضایی یا اداری، دستور یا فرمان قانونی در محدوده‌ی سرزمینی
          جمهوری اسلامی ایران یا هریک از نقاطی که آروان در آن دارای پاپ‌سایت یا
          سِروِر است و نیز احکام صادره از مراجع ذی‌صلاح بین‌المللی، حسب‌مورد
          می‌تواند بر هریک از مقررات محرمانگی گفته‌شده یا گفته‌نشده اولویت داشته
          ‌باشد؛ به این معنا که اجرای هریک از آن‌ها را تعلیق یا متوقف یا لغو کند
          و در این موقعیت هیچ‌گونه اعتراضی پذیرفته نخواهد بود و ماندگار مدار
          آوین هیچ‌گونه مسوولیتی را در این زمینه برعهده نخواهد داشت. حساب کاربری
          برای ساخت حساب کاربری لازم است اطلاعات خود را مطابق اطلاعات مندرج در
          مدارک شناسایی رسمی خود وارد کنید. با واردکردن اطلاعات نادرست در حساب
          کاربری، مسوولیت آن به‌عهده‌ی شما خواهد بود. اگر یک یا چند مورد از
          اطلاعات شما تغییر کرد، لازم است در سریع‌ترین زمان آن را در حساب کاربری
          خود ویرایش و به‌روز کنید. مسوولیت واردکردن اطلاعات به‌شکل صحیح و کامل
          و حفاظت از گذرواژه‌ی انتخابی‌تان صرفا به‌عهده‌ی شما خواهد بود و اگر
          ضعف گذرواژه منجر به نفوذ به‌ حساب کاربری شما شود، مسوولیتی متوجه
          ماندگار مدار آوین نیست. مسوولیت محافظت از رمز عبور ماندگار مدار آوین
          تلاش کرده است تا کاربران نتوانند از رمز عبور ساده استفاده کنند اما
          ممکن است کاربران از رمزهای عبور متداول استفاده کنند یا در حفظ و
          نگه‌داری رمز عبور خود دقت کافی را نداشته باشند. در این موقعیت با
          سواستفاده از آن رمز عبور ممکن است وب‌سایت توزیع‌شده و امن‌شده در
          ماندگار مدار آوین، با اختلالاتی مواجه شود یا مورد سوء استفاده قرار
          گیرد. در این موقعیت ماندگار مدار آوین هیچ‌گونه مسوولیتی را قبول نخواهد
          کرد.
          <br />
          ماندگار مدار آوین به‌شدت تاکید می‌کند از رمز عبورهای پیچیده استفاده
          کنید و از انتشار آن به‌شکل مجازی و فیزیکی بپرهیزید. ارتباطات دیجیتال
          با استفاده از خدمات ماندگار مدار آوین، شما موافقت می‌کنید ارتباطات
          دیجیتال مانند دریافت اطلاعیه، ایمیل، پیامک، اعلان، پشتیبانی به‌شکل
          پاسخ به «تیکت» و... جایگزین روش‌های سنتی ارتباطات مانند فکس، تلفن،
          نامه و مراجعه حضوری شود؛ در نتیجه، هرگونه مکاتبه به‌روش‌های دیجیتال
          ذکرشده از نظر قانونی معتبر خواهد بود. عضویت خبرنامه با ساخت حساب
          کاربری ماندگار مدار آوین موافقت می‌کنید ایمیل‌ها و پیامک‌های (SMS)
          اطلاع‌رسانی و خبرنامه‌ی ماندگار مدار آوین برای‌تان ارسال شود. اگر
          تمایلی به دریافت این موارد ندارید، می‌توانید اشتراک خود را لغو کنید،
          اما در این موقعیت، ماندگار مدار آوین مسوولیتی در قبال بی‌اطلاعی شما از
          پیام‌هایی که از این مسیرهای ارتباطی منتشر می‌شوند، نخواهد داشت.
          استفاده از خدمات رایگان اگر از خدمات رایگان ماندگار مدار آوین استفاده
          می‌کنید، مشمول پشتیبانی اختصاصی، قرارداد سطح کیفیت خدمات و جبران خسارت
          اختلال نمی‌شوید. ماندگار مدار آوین در تغییر قابلیت‌ها و ویژگی‌های سطح
          رایگان خدمات خود در هر زمان، یا حذف آن به‌طور کلی، مختار است و ارایه‌ی
          رایگان این خدمات یا تداوم آن‌ها هیچ‌گاه تعهدی برای ماندگار مدار آوین
          ایجاد نخواهد کرد. نسخه‌ی آزمایشی آن دسته از خدمات ماندگار مدار آوین که
          در وضعیت «نسخه‌ی آزمایشی» و «Beta» اعلام می‌شوند، در وضعیت پایدار
          نیستند و نباید از سوی کاربران برای تولید و عرضه‌ی محصول نهایی و
          اصلی‌‌شان به‌کار گرفته شوند. ماندگار مدار آوین این اختیار را دارد که
          هر زمان در خدمات نسخه‌ی آزمایشی خود تغییر ایجاد کند یا اطلاعات موجود
          روی این دسته از خدمات را حذف کند. در مورد اخیر، بازگردانی اطلاعات ممکن
          نخواهد بود. کد هدیه کد هدیه‌ای که ماندگار مدار آوین برای کاربر صادر
          می‌کند تنها برای همان کاربر امکان استفاده دارد و فروش یا واگذاری یا
          انتقال آن به کاربر دیگر ممکن نیست. مبلغ کد هدیه به‌شکل اعتبار به حساب
          کاربر برای استفاده از خدمات ماندگار مدار آوین اختصاص داده می‌شود و
          قابلیت تسویه‌ی ریالی ندارد. این بدان معناست که در زمان لغو خدمات و
          درخواست بازگرداندن وجه، مبلغ کد(های) هدیه لحاظ نمی‌شود. هر کد هدیه‌ای
          که ماندگار مدار آوین صادر می‌کند دارای تاریخ انقضای مشخص است و چنان‌چه
          کاربر در مدت زمان معتبر از کد هدیه استفاده نکند، کد باطل شده و دوباره
          صادر نخواهد شد. لغو خدمات اگر وضعیت مالی حساب کاربری بدهکار باشد، برای
          لغو استفاده از خدمات ماندگار مدار آوین ابتدا باید هزینه‌ی محاسبه ‌شده
          را پرداخت کنید. برای لغو خدمات لازم است در حساب کاربری‌تان، همه‌ی
          خدمات را متوقف و اطلاعاتی را که روی هر سرویس دارید، حذف کنید وگرنه
          مسوولیت تسویه‌حساب به‌عهده‌ی شما خواهدبود.
          <br />
          لغو استفاده‌ی شما از یک یا چند سرویس ماندگار مدار آوین، هم‌زمان به این
          معنی است که رسما اعلام می‌کنید به اطلاعات روی سرویس‌ها نیازی ندارید.
          <br />
          برای بازگرداندن وجه به حساب بانکی کاربر، لازم است دارنده‌ی حساب کاربری
          ماندگار مدار آوین، هم‌نام با صاحب حساب بانکی باشد که شماره‌ی شبای آن
          را به ما اعلام می‌کنید. هم‌چنین ارسال تصویر کارت ملی صاحب حساب الزامی
          است.
          <br />
          در حال حاضر امکان حذف یا غیرفعال کردن حساب کاربری وجود ندارد. دامنه‌ی
          خدمات پشتیبانی فنی کارشناسان پشتیبانی فنی ماندگار مدار آوین تنها در
          حوزه‌ی زیرساخت اینترنت اشیاء و مشکلات مرتبط با محصولات ماندگار مدار
          آوین به ارایه پشتیبانی می‌پردازند و مسوولیتی در قبال نصب، نگه‌داری و
          رفع اشکال سرویس‌ها و نرم‌افزارهایی که کاربران به کمک زیرساخت ماندگار
          مدار آوین راه‌اندازی می‌کنند یا زیرساخت‌ها و نرم‌افزارهایی که به هر
          شکل به ماندگار مدار آوین متصل می‌کنند، ندارند. پروانه‌های نرم‌افزارهای
          شخص ثالث مسوولیت رعایت قوانین مرتبط با پروانه‌های (License)
          نرم‌افزارهایی که شما به کمک زیرساخت ماندگار مدار آوین نصب و راه‌اندازی
          می‌کنید برعهده‌ی شماست و ماندگار مدار آوین مسوولیتی نخواهد داشت. امنیت
          نرم‌افزارهای شخص ثالث ماندگار مدار آوین به‌عنوان عرضه‌کننده‌ی خدمات
          زیرساخت، تنها مسوولیت تضمین امنیت محصولات خود را برعهده دارد و چنان‌چه
          کاربری روی زیرساخت ماندگار مدار آوین سرویسی ایجاد کند یا نرم‌افزاری
          نصب کند که منجر به ضعف امنیتی شود یا اطلاعات وی هک شده و به سرقت برود،
          مسوولیتی متوجه ماندگار مدار آوین نخواهد بود؛ با این حال، این حق برای
          ماندگار مدار آوین محفوظ است که به هنگام ایراد هرگونه زیان یا اخلال در
          سرویس‌ها و خدمات قابل ارایه از سوی ماندگار مدار آوین در اثر نصب هرگونه
          بدافزار نسبت به‌ جبران خسارت و پی‌گیری قانونی اقدام کند. تهیه نسخه‌ی
          پشتیبان شما با استفاده از خدمات ماندگار مدار آوین موظف به تهیه‌ی
          نسخه‌ی پشتیبان (Backup) از آن دسته از اطلاعاتی می‌شوید که روی زیرساخت
          ماندگار مدار آوین دارید. ماندگار مدار آوین مسوولیتی در قبال تهیه‌ی
          نسخه‌ی پشتیبان از اطلاعات کاربران و بازگرداندن اطلاعات از دست رفته، که
          به‌دلیل خطای کاربران یا هر دلیل دیگری رخ داده ‌است، ندارد.
          <br />
          ما به‌شکل پیش‌فرض در نظر می‌گیریم که کاربران از داده‌های حساس خود مرتب
          نسخه‌ی پشتیبان تهیه می‌کنند و مسوولیت آن را بر عهده دارند؛ از این رو
          ماندگار مدار آوین مسوولیتی در قابل داده‌ها و اطلاعات ازدست‌رفته برعهده
          نخواهیم‌گرفت. جبران خسارت با پیش‌آمدن اختلال در بهره‌برداری شما از هر
          یک از خدمات ماندگار مدار آوین، جبران خسارت براساس قرارداد سطح کیفیت
          خدمات (SLA) و به شیوه‌ی تخصیص اعتبار به حساب کاربری شما انجام می‌شود و
          این اعتبار قابلیت تسویه‌ی ریالی ندارد. تخصیص اعتبار به‌عنوان جبران
          خسارت تنها برای کاربران مشمول قرارداد SLA انجام می‌شود و کاربرانی که
          دارای حساب منفی و بدهی به شرکت باشند شامل آن نخواهند شد. برای استفاده
          از این امکان لازم است شما نسبت به ارسال نامه‌ی رسمی یا ثبت «تیکت» در
          سامانه‌ی پشتیبانی ماندگار مدار آوین با عنوان «درخواست خدمات اعتباری» و
          حاوی گزارش‌ها و لاگ‌های سیستمی نشان‌دهنده‌ی اختلال‌های به‌وجود آمده،
          اقدام کنید. ماندگار مدار آوین هیچ‌گونه مسوولیتی در جبران خسارت‌ها و
          زیان‌های وارده یا منافع ممکن‌الحصولِ فوت‌شده فراتر از آن‌چه در SLA درج
          شده است ندارد و چیزی جز تخصیص خدمات اعتباری، تحت هیچ شرایطی برعهده‌ی
          نخواهد گرفت. قیمت‌گذاری و تغییرات قیمت: قیمت تمامی سرویس‌ها و محصولات
          ماندگار مدار آوین به ‏شیوه‌ی Pay As You Go و مطابق آن‌چه در صفحه
          قیمت‌گذاری آمده است، به‌شکل ساعتی و بر اساس قیمت روز محاسبه می‏‌شود.
          تغییرات قیمت محصولات ماندگار مدار آوین، پیش از اجرایی شدن، از راه سایت
          یا ایمیل به اطلاع‌ کاربران می‌‏رسد و از زمان تغییر قیمت، هزینه‌ها بر
          اساس قیمت‌گذاری جدید، برای تمام مشتریان (قدیم و جدید) محاسبه خواهد شد.
          شرایط و روند قطع سرویس‌های ماندگار مدار آوین با توجه به شیوه‌ی
          قیمت‌گذاری Pay As You Go و Post Paid بودن استفاده از محصولات ماندگار
          مدار آوین، با منفی شدن کیف پول، ایمیل و پیامک یادآوری شارژ حساب برای
          کاربران فرستاده می‌شود. اگر از رایانش ابری استفاده می‌کنید: • بلافاصله
          پس از صفر شدن موجودی حساب،‌ دسترسی شما به پنل رایانش ابری قطع می‌شود.
          • پس از گذشت ۲۴ ساعت از زمان صفر شدن موجودی حساب، شبکه‌ی اینترنت اشیاء
          شما قطع می‌شود و به پنل و SSH دسترسی نخواهید داشت. • پس از گذشت ۴۸
          ساعت از زمان صفر شدن موجودی حساب، پنل اینترنت اشیاء شما خاموش می‌شوند
          اما هزینه‌ی فضای ذخیره‌سازی هم‌چنان محاسبه و از اعتبار شما کم می‌شود.
          • پس از گذشت ۱ هفته از زمان صفر شدن موجودی حساب، پنل، اسنپ‌شات‌ها،
          دیسک‌ها و تمام IPهای شما پاک می‌شوند و امکان بازگرداندن اطلاعات آن‌ها
          به هیچ‌وجه وجود نخواهد داشت. ماندگار مدار آوین در برابر از دست رفتن
          داده‌های‌تان بر اثر مواردی که در بالا ذکر شد، مسوولیتی ندارد. شما لازم
          است برای کاهش ریسک‌های احتمالی، مکانسیم‌های کلاسترینگ را در سطح
          نرم‌افزار پیاده‌سازی کنید. مالیات بر ارزش‌افزوده قیمت نهایی خدمات
          ماندگار مدار آوین پس از احتساب مالیات بر ارزش‌افزوده مطابق قوانین
          مالیاتی کشور، در صورت‌حساب شما درج می‌شود و با تغییر درصد مالیات بر
          ارزش‌افزوده مطابق قانون، این تغییر در صورت‌حساب کاربران ماندگار مدار
          آوین نیز لحاظ خواهد شد. حوادث غیرقابل اجتناب ماندگار مدار آوین در زمان
          پیش‌آمدن موارد غیرقابل اجتناب مانند بلایای طبیعی، جنگ، شورش، اعتصاب،
          تحریم، قطعی اینترنت و ارتباطات داخلی و بین‌المللی، مسوولیتی در قبال
          انجام‌نشدن تعهدات خود ندارد. مادامی که این شرایط به تشخیص ماندگار مدار
          آوین طولانی شود و ارایه‌ی خدمات ما را متاثر و معلق کند، هیچ‌گونه
          مسوولیت یا تعهدی متوجه ماندگار مدار آوین نخواهد بود. هر چند تلاش
          می‌کنیم آثار این موارد بر عرضه‌ی خدمات به کاربران کاهش یابد.
          محفوظ‌بودن حق تغییر ماندگار مدار آوین مختار است در هر زمان و بدون
          اطلاع کاربر، مواردی مانند مشخصات فنی، سطوح (پلن‌های) محصولات و شرایط
          استفاده از خدمات خود را کلی یا جزیی تغییر دهد. آخرین نسخه این موارد
          روی سایت ماندگار مدار آوین بارگذاری خواهد شد و از همین صفحه در دسترس
          کاربران قرار خواهد گرفت.
          <br />
          آخرین تاریخ به‌روزرسانی: شهریور ۱۴۰۰
        </p> */}
      </div>
    </div>
  );
};

export { TermsAndConditions };
